import Styles from './RemoveGuestModal.module.scss'
import { ReactComponent as BranchIcon } from 'assets/icons/version16.svg'
import { UnmergedBranchRowProps } from './Types'

const UnmergedBranchRow = ({ branch }: UnmergedBranchRowProps) => {
  return (
    <div className={Styles.branchRow}>
      <BranchIcon />
      {branch.title}
    </div>
  )
}

export { UnmergedBranchRow }
